import { render, staticRenderFns } from "./gkclass.vue?vue&type=template&id=1fd30798&scoped=true"
import script from "./gkclass.vue?vue&type=script&lang=js"
export * from "./gkclass.vue?vue&type=script&lang=js"
import style0 from "./gkclass.vue?vue&type=style&index=0&id=1fd30798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd30798",
  null
  
)

export default component.exports